<ng-container *ngIf="appState$ | async as appState">
  <mat-accordion
    class="comparador-universidad-container"
    ngClass.xs="comparador-universidad-container comparador-xs"
    *ngIf="appState.ui.comparadorInferior.open">
    <mat-expansion-panel
      [expanded]="!appState.ui.comparadorInferior.collapsed"
      class="bg-morado-sunedu comparador-expansion-panel"
      (opened)="handleColapsarComparador(true)"
      (closed)="handleColapsarComparador(false)">
      <mat-expansion-panel-header class="bg-morado-sunedu p-t-15 p-b-15">
        <mat-panel-title
          class="bg-morado-sunedu comparador-panel-title"
          fxLayoutAlign="flex-start center">          
          <ng-container [ngPlural]="appState.globalConfig.comparador.universidades.length">
            <ng-template ngPluralCase="=1">Seleccionar al menos dos universidades para comparar</ng-template>
            <ng-template ngPluralCase="other">{{appState.globalConfig.comparador.universidades.length}} universidades seleccionadas</ng-template>
          </ng-container>
          <span class="flex-spacer"></span>
          <div fxLayout.xs="column-reverse">
            <button
              *ngIf="!appState.ui.mobileLayout||!appState.ui.comparadorInferior.collapsed"
              mat-flat-button
              class="bg-blanco-sunedu text-naranja-sunedu rounded-full btn-comparar m-r-5"
              ngClass.xs="btn-comparar-movil"
              (click)="handleClickQuitarTodo($event)">
              Quitar todo
            </button>
            <button
              mat-flat-button
              ngClass.xs="btn-comparar-movil"
              class="bg-naranja-sunedu rounded-full btn-comparar m-l-5"
              (click)="handleClickComparar($event)" [disabled]="2 > appState.globalConfig.comparador.universidades.length">
              Comparar
            </button>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div
        fxLayout="row wrap"
        fxLayoutGap="5px grid">
        <ng-container *ngFor="let item of appState.globalConfig.comparador.universidades">
          <div
            fxFlex="33%"
            fxFlex.sm="50%"
            fxFlex.xs="100%">
            <div
              class="item-universidad-seleccionada"
              fxLayout="row"
              fxLayoutAlign="flex-start center">
              {{item.nombre}}
              <span class="flex-spacer"></span>
              <button
                mat-button
                class="p-l-5 p-r-5"
                (click)="handleDeleteUniversidad(item)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>

          </div>
        </ng-container>
      </div>

    </mat-expansion-panel>
  </mat-accordion>

  <!-- <div
    [ngClass]="{
        'comparador-collapsed': appState.ui.comparadorInferior.collapsed, 
        'comparador-expanded': !appState.ui.comparadorInferior.collapsed
    }"
    [ngClass.xs]="{
        'comparador-collapsed': appState.ui.comparadorInferior.collapsed, 
        'comparador-expanded-xs': !appState.ui.comparadorInferior.collapsed
    }"
    class="comparador-universidad-container bg-morado-sunedu"
    fxLayoutAlign="center flex-start"
    *ngIf="appState.ui.comparadorInferior.open">

    <div
      class="comparador-section"
      fxLayout="column">
      <div fxLayoutAlign="flex-start flex-start">
        <div
          class="cantidad-seleccionada m-t-5"
          [ngClass.xs]="'cantidad-seleccionada-xs'">
          {{appState.globalConfig.comparador.universidades.length}}
          <ng-container [ngPlural]="appState.globalConfig.comparador.universidades.length">
            <ng-template ngPluralCase="=1">universidad seleccionada</ng-template>
            <ng-template ngPluralCase="other">universidades seleccionadas</ng-template>
          </ng-container>
        </div>
        <span class="flex-spacer"></span>
        <button
          class="btn-collapse-comparador"
          mat-icon-button
          (click)="handleColapsarComparador(appState.ui.comparadorInferior.collapsed)">
          <mat-icon *ngIf="appState.ui.comparadorInferior.collapsed">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="!appState.ui.comparadorInferior.collapsed">keyboard_arrow_down</mat-icon>
        </button>
      </div>

      <div
        fxFlex="33%"
        fxFlex.sm="50%"
        fxFlex.xs="100%">
        

      </div>

    </div>

  </div> -->
</ng-container>
